import { useState } from "react";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";

import constants from "../../assets/constants";
import { getWebchatConfiguration } from "../../utils/botConfigurations";
import OmniEditButton from "../ui/omniEditButton";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const CreatorHarnessNavigation = props => {
  const [availableBots] = useState(getWebchatConfiguration().filter(obj => obj.botId !== "guid"));

  const { enqueueSnackbar } = useSnackbar();

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (availableBots != null) {
      setTitleText(`${availableBots.length} Active Bots`);
    } else {
      setTitleText("Loading...");
      props.loadOrganizationsRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableBots]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"Test Harness"} text={titleText}></WidgetTitle>

      {availableBots == null && <WidgetSkeleton />}
      {availableBots != null && (
        <WidgetList>
          {availableBots.map((botConfig, index) => {
            return (
              <ListItem
                key={`assessment${index}`}
                disableGutters={true}
                sx={{
                  padding: theme.spacing(1),
                  paddingTop: 0,
                  paddingBottom: 0,
                  marginBottom: theme.spacing(1),
                  borderRadius: theme.spacing(1),
                  backgroundColor: alpha(theme.palette.info.main, 0.75),
                  color: theme.palette.info.contrastText,
                  cursor: "pointer",
                  boxShadow: theme.shadows[3],
                  userSelect: "none",
                  webkitUserSelect: "none",
                }}
                onClick={e => {
                  e.stopPropagation();
                  let url = `${window.location.origin}${constants.appPaths.appPathHarness}?botID=${botConfig.clientId}`;
                  navigator.clipboard.writeText(url);
                  enqueueSnackbar("URL Copied", {
                    variant: "success",
                  });
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="h6"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: theme.palette.info.contrastText,
                        marginTop: 0,
                      }}
                    >
                      {`${botConfig.displayIdentifier}`}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginTop: "-6px",
                        color: theme.palette.info.contrastText,
                        minimumHeight: 20,
                      }}
                    >
                      Click to copy Harness URL to clipboard
                    </Typography>
                  }
                />
                <OmniEditButton
                  title={"Manage"}
                  sx={{
                    marginTop: "2px",
                    marginRight: "2px",
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    let url = `${constants.appPaths.appPathHarness}?botID=${botConfig.clientId}`;
                    props.history.push(url);
                  }}
                  icon={
                    <OpenInNewIcon
                      sx={{
                        color: theme.palette.info.contrastText,
                        height: 36,
                        width: 36,
                      }}
                    />
                  }
                />
              </ListItem>
            );
          })}
        </WidgetList>
      )}
    </Widget>
  );
};

export default withRouter(CreatorHarnessNavigation);
